// extracted by mini-css-extract-plugin
export default {"footerLinks":"footer-links_footerLinks__LUey1"};